var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSocialmediaf1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 31,
    viewBox: "0 0 16 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5103 0.0404013C10.2117 0.0706748 9.52494 0.228097 9.10094 0.3613C7.17207 0.960714 5.71496 2.44411 5.08196 4.44821C4.74157 5.532 4.70574 5.90739 4.67588 8.72888L4.64602 11.3203H0V16.8906H4.65796V30.998H10.3311V16.8906H15.0189L15.3653 14.1478C15.5564 12.6463 15.7117 11.3929 15.7057 11.3627C15.7057 11.3384 14.4934 11.3203 13.0124 11.3203H10.3192L10.3431 9.15271C10.367 7.09411 10.3729 6.97302 10.5043 6.56735C10.6118 6.22829 10.7073 6.08298 10.9522 5.83474C11.5135 5.2656 12.1346 5.1445 14.589 5.1445H15.8848V0.191769L15.5445 0.15544C14.3322 0.0222373 11.3224 -0.050419 10.5103 0.0404013Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSocialmediaf1);
export default __webpack_public_path__ + "static/media/socialmediaf1.53baa33392d9ecb8cf0b415d34953998.svg";
export { ForwardRef as ReactComponent };